module.exports = __webpack_public_path__ + "img/img_empty.f112a9f4.svg";